const InsightCard = ({ card }) => {
  const borderColor =
    card.type === "danger"
      ? "border-red-200 bg-red-50/60"
      : card.type === "warning"
        ? "border-orange-200 bg-orange-50/60"
        : card.type === "success"
          ? "border-green-200 bg-green-50/60"
          : "border-slate-100 bg-slate-50"

  const titleColor =
    card.type === "danger"
      ? "text-red-800"
      : card.type === "warning"
        ? "text-orange-800"
        : card.type === "success"
          ? "text-green-800"
          : "text-slate-800"

  return (
    <div
      className={`flex gap-3.5 p-4 rounded-xl border transition-all duration-200 hover:shadow-sm ${borderColor}`}
    >
      <div className="mt-0.5 shrink-0">{card.icon}</div>

      <div className="flex flex-col gap-0.5">
        <h4 className={`font-semibold text-sm ${titleColor}`}>{card.title}</h4>

        <p className="text-xs leading-relaxed text-slate-600">{card.desc}</p>
      </div>
    </div>
  )
}

export default InsightCard
